var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTiktok = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon__tiktok",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.71 0c.264 2.27 1.531 3.624 3.734 3.768v2.554c-1.277.125-2.395-.293-3.696-1.08v4.777c0 6.067-6.615 7.964-9.275 3.614-1.708-2.798-.662-7.71 4.82-7.906V8.42a7.933 7.933 0 0 0-1.272.312c-1.22.413-1.91 1.186-1.719 2.55.37 2.61 5.161 3.383 4.763-1.72V.006h2.645V0Z",
  clipRule: "evenodd"
}))));
export default SvgTiktok;